<template>
    <div>
        <div class="grid-center">
            <Person class="col-12 person"></Person>
        </div>

        <div class="pool" v-for="(pool, key) in poolList" :key="key">
            <Pool :pool="pool" :poolindex="key"></Pool>
        </div>
    </div>
</template>

<script>
    import Pool from '@/components/Pool.vue'
    import Person from '@/components/Person.vue'
    export default {
        name: 'Questionnaire',
        props: ['sha256'],
        components: { Pool, Person },
        computed: {
            poolList() {
                return this.$store.getters.POOLS
            },
            results() {
                return this.$store.getters.Q_ONE
            }

        }
    }
</script>

<style scoped>
    .pool {
        border: darkred solid 2px;
        margin-bottom: 20px;
        padding-left: 0px;
        padding-right: 35px;
    }
    .person {
        text-align: center;
        display:inline-block;
    }
</style>